import React from 'react';

import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { OrderHistory } from '../../../Constant';
import OrderHistoryTable from './OrderHistoryTable';

const OrderHistoryContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs justify='end' pageTitle='Recent Orders' parent='Ecommerce' title='Recent Orders' />
      <Card>
        <CardHeader className='pb-0'>
          <H5>{OrderHistory}</H5>
        </CardHeader>
        <CardBody>
          <OrderHistoryTable />
        </CardBody>
      </Card>
    </Container>
  );
};

export default OrderHistoryContainer;
